angular
  .module('common.sw', []);